import auth, { AuthParams } from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';

export type IRoute = AuthParams & {
  name: string;
  key: string;
  // 当前页是否展示面包屑
  breadcrumb?: boolean;
  children?: IRoute[];
  // 当前路由是否渲染菜单项，为 true 的话不会在菜单中显示，但可通过路由地址访问。
  ignore?: boolean;
};

export const routes: IRoute[] = [
  {
    name: '欢迎页',
    key: 'welcome',
    requiredPermissions: [],
  },
  {
    name: '任务管理',
    key: 'task',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '任务列表',
        key: 'task/index',
        requiredPermissions: [],
        oneOfPerm: false,
      },
      {
        name: '任务详情',
        key: 'task/detail',
        ignore: true,
        requiredPermissions: [],
        oneOfPerm: false,
      },
    ],
  },
  {
    name: '向量管理',
    key: 'vector',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '向量列表',
        key: 'vector/index',
        requiredPermissions: [],
        oneOfPerm: false,
      },
    ],
  },
  {
    name: '系统设置',
    key: 'setting',
    requiredPermissions: [],
    oneOfPerm: true,
    children: [
      {
        name: '模型管理',
        key: 'setting/models',
        requiredPermissions: [],
        oneOfPerm: false,
      },
      {
        name: '其他设置',
        key: 'setting/setting',
        requiredPermissions: [],
        oneOfPerm: false,
      },
    ],
  },
];

export const getName = (path: string, routes) => {
  return routes.find((item) => {
    const itemPath = `/${item.key}`;
    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};

const useRoute = (userPermission): [IRoute[], string] => {
  const filterRoute = (routes: IRoute[], arr = []): IRoute[] => {
    if (!routes.length) {
      return [];
    }
    for (const route of routes) {
      const { requiredPermissions, oneOfPerm } = route;
      let visible = true;
      if (requiredPermissions) {
        visible = auth({ requiredPermissions, oneOfPerm }, userPermission);
      }

      if (!visible) {
        continue;
      }
      if (route.children && route.children.length) {
        const newRoute = { ...route, children: [] };
        filterRoute(route.children, newRoute.children);
        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({ ...route });
      }
    }

    return arr;
  };

  const [permissionRoute, setPermissionRoute] = useState(routes);

  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission)]);

  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];
    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }
    return '';
  }, [permissionRoute]);

  return [permissionRoute, defaultRoute];
};

export default useRoute;
